export default __webpack_public_path__ + "static/media/preck-chein.29388d2b.png";